// eslint-disable-next-line n/no-process-env -- It's ok
const isProduction = process.env.NODE_ENV === "production";

export class InternalRenderError extends Error {
  constructor() {
    super("Internal render error");
    this.name = "InternalRenderError";
  }
}

export const handleInternalRenderException = (error: unknown) => {
  if (isProduction) {
    console.log(error);
    throw new InternalRenderError();
  }

  throw error;
};
